<template>

  <svg
    t="1639131683779"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3989"
    width="64"
    height="64"
  ><path d="M832.990625 494.253125" p-id="3990" /><path d="M567.659375 510.678125L894.134375 185.6375c15.440625-15.384375 15.525-40.275 0.16875-55.74375-15.384375-15.496875-40.246875-15.525-55.6875-0.16875L512.028125 454.821875 188.309375 129.865625C173.009375 114.48125 148.0625 114.425 132.65 129.78125 117.2375 145.165625 117.209375 170.1125 132.565625 185.553125l323.634375 324.871875L129.865625 835.26875c-15.440625 15.384375-15.525 40.275-0.16875 55.74375 7.678125 7.734375 17.803125 11.615625 27.928125 11.615625 10.040625 0 20.08125-3.825 27.759375-11.475l326.390625-324.928125 326.671875 327.909375C846.153125 901.896875 856.25 905.75 866.346875 905.75c10.06875 0 20.1375-3.853125 27.815625-11.503125 15.384375-15.384375 15.440625-40.275 0.084375-55.715625L567.659375 510.678125 567.659375 510.678125zM567.659375 510.678125" p-id="3991" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconClose',
} as DefineComponent
</script>